/** Cibles volumétriques — démo commerciale ITaaS Hospitol / pharmacie (tenant demo-hospitol). */
export const DEMO_COMMERCIAL_TARGETS = {
  patients: 150,
  /** Patients uniques avec admission datée du jour (dashboard accueil). */
  patientsToday: 24,
  products: 25,
  pharmacyInvoices: 60,
  mobileMoneyPaymentsToday: 8,
  prescriptionsQueue: 12,
  cashierQueue: 8,
  /** Factures déjà payées (historique caisse / trésorerie). */
  paidInvoices: 28,
  lowStockAlerts: 3,
  insurancePending: 7,
  notifications: 15,
} as const;

export const DEMO_COMMERCIAL_TAG = "[DÉMO-COM]";
export const DEMO_COMMERCIAL_VERSION = "commercial-v6";
